<template>
  <sc-page-base title="Integrações" :loading="loading" class="page-integrations">
    <div class="columns search_bar">
      <div class="column search_bar__input_container">
        <sc-input
          placeholder="Pesquisar transportadoras"
          icon="search"
          @input="searchAppSelfService"     
        />
      </div>
    </div>
    <div class="columns">
      <div class="column is-three-quarters">
        <div class="page-body">
          <app-list :isSearching="isSearching" />
        </div>
      </div>
    </div>

  </sc-page-base>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { ScPageBase, ScInput, ScField } from '@intelipost-js/secure-components';
import { Url, Auth, Storage } from '@intelipost-js/secure-providers';
import AppList from '../components/app-list/AppList.vue';

const { mapState, mapActions } = createNamespacedHelpers(
  'integrations/integrationsAppSelfService',
);

export default {
  name: 'integrations-self-service',

  props: {
    appListSearch: {
      type: Object,
    },
  },

  data() {
    return {
      isSearching: false,
    };
  },

  computed: {
    ...mapState(['loading', 'selfServiceList']),
    getLinkNewLogisticProvider() {
      const { client_id, email } = Auth.getUser();
      const { common_name, official_name } = Storage.get('client') || {};

      const clientName = encodeURIComponent(official_name || common_name || '');
      const params = {
        control94203943: client_id,
        control94203931: clientName,
        control94203950: email,
      };

      return Url.toQueryString('https://form.123formbuilder.com/5760685/form', params);
    },
  },

  methods: {
    ...mapActions(['getAppSelfServiceListApps', 'setFilteredAppList']),

    searchAppSelfService(event) {
      this.isSearching = true;

      const searchList = event.toLowerCase();
      const newSearchList = this.selfServiceList.filter((app) => {
        const appName = app.app_name.toLowerCase();
        return appName.includes(searchList) || appName.startsWith(searchList);
      });
      if (newSearchList.length > 0) {
        this.setFilteredAppList(newSearchList);
      } else {
        this.setFilteredAppList([]);
      }
    },
  },

  mounted() {
    this.$root.$on('clean-search', () => this.searchAppSelfService(''));
    this.getAppSelfServiceListApps();
  },

  components: {
    ScPageBase,
    ScInput,
    ScField,
    AppList,
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.page-integrations {

  .sc-card--link {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .sc-card__content {
    min-height: 130px;
    flex-grow: 1;
  }

  .sc-card__content > div {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .page-body {
    display: flex;
    flex-direction: column;
  }
  .search_bar {
    position: sticky;
    top: 4.85rem;
    top: var(--header-height);
    z-index: 1;
    .column {
      padding-top: 0.5rem;
    }
    &__input_container {
      margin-left: 0.25rem;
    }
    .input {
      padding: 1.5rem;
      padding-left: 3.0rem;
      width: 82rem;
    }
  }
  @keyframes search_bar_sticky {
    to {
      background-color: white;
      padding: 1.5rem;
      box-shadow: 0 3px 3px rgba(10,10,10,0.1),0 1px 0 0 rgba(10,10,10,0.1);
    }
  }
  @media (prefers-reduced-motion: no-preference) {
    .search_bar {
      animation: 1000000s linear 0s 1 both search_bar_sticky;
      animation-timeline: scroll();
      animation-range: 0 var(--header-height);
    }
  }
  i.fas.fa-search.fa-lg {
    margin: 20px 0px 8px 20px;
    color: $primary;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/self-service-list/IntegrationsAppSelfServiceList.vue?d21a647a